import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createUpdatePersonaGroupCommand } from '../../../api/commands/factory/createPersonaCommands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class UpdatePersonaGroup extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'UpdatePersonaGroup';

    public constructor(public id: string, public group: string) {
        super(UpdatePersonaGroup.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: UpdatePersonaGroup): Promise<boolean> => {
    return await useSendCommandAsync(action, {
        createCommand: async () => await createUpdatePersonaGroupCommand(action),
    });
};

const reducer = (state: StorymapState, action: UpdatePersonaGroup): void => {
    const persona = state.personas.find((x) => x.id === action.id);

    persona.group = action.group;
};

//@ts-ignore
registerMiddleware(UpdatePersonaGroup.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(UpdatePersonaGroup.ACTION_TYPE, reducer);
